/**
 * CreatureCardSkeleton Component
 *
 * Skeleton loading placeholder for creature cards in the gallery.
 * Displays a shimmer animation while actual creature data is loading.
 *
 * Structure matches CreatureCard:
 * - Image placeholder (square, aspect-ratio 1)
 * - Title placeholder
 * - Abilities placeholders (3 tags)
 * - Metadata placeholders (race, class, date)
 *
 * Spec: docs/specs/L3-features/F-GALLERY-SKELETON.md
 */

import React from 'react';
import styles from './CreatureCardSkeleton.module.css';

export const CreatureCardSkeleton: React.FC = () => {
  return (
    <div
      className={styles.skeletonCard}
      aria-hidden="true"
      style={{ height: '320px' }}
    >
      {/* Screen reader text */}
      <span className={styles.srOnly}>Loading creature card...</span>

      {/* Image placeholder */}
      <div
        className={`${styles.skeletonImageContainer} ${styles.shimmer}`}
        data-testid="skeleton-image"
      />

      {/* Content area */}
      <div className={styles.skeletonContent}>
        {/* Title placeholder */}
        <div
          className={`${styles.skeletonTitle} ${styles.shimmer}`}
          data-testid="skeleton-title"
        />

        {/* Abilities placeholders */}
        <div
          className={styles.skeletonAbilities}
          data-testid="skeleton-abilities"
        >
          <div className={`${styles.skeletonAbility} ${styles.shimmer}`} />
          <div className={`${styles.skeletonAbility} ${styles.shimmer}`} />
          <div className={`${styles.skeletonAbility} ${styles.shimmer}`} />
        </div>

        {/* Metadata placeholders */}
        <div
          className={styles.skeletonMetadata}
          data-testid="skeleton-metadata"
        >
          <div className={`${styles.skeletonMetaItem} ${styles.shimmer}`} />
          <div className={`${styles.skeletonMetaItem} ${styles.shimmer}`} />
          <div className={`${styles.skeletonMetaItem} ${styles.shimmer}`} />
        </div>
      </div>
    </div>
  );
};

export default CreatureCardSkeleton;
